import React, { useState } from 'react';
import CustomFileUpload from "./CustomFileUpload";
import { Button } from 'shards-react';
import ProgressBarImage from './ProgressBarImage';


const UploadDisplayLogo = ({ userId }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);

  // Checks if the type is image or pdf and assigns the content type
  const types = ['image/jpeg', 'image/png'] ;
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileUpload = () => {

    if (selectedFile && types.includes(selectedFile.type)) {
      setFile(selectedFile);
      setError('');
    } else {
      setFile(null);
      setError('Please select an image (PNG/JPG)');
    }
    setSelectedFile(null)
  };

  const handleFileSelect = (e) =>{
    let selectedFile = e.target.files ? e.target.files[0] : null;
    setSelectedFile(selectedFile);
  }
  return (
    <div>
      <CustomFileUpload userId={userId} handleFileSelect={handleFileSelect} selectedFile={selectedFile}/>
      <Button className="mt-2" onClick={() => {handleFileUpload()}}>Upload Image</Button>
      <div className="output">
        {error && <div>{error}</div>}
        {/* {file && <div>{file.name}</div>} */}
        {file && <ProgressBarImage userId={userId} file={file} setFile={setFile} />}
      </div>
    </div>
  );
}

export default UploadDisplayLogo;